import { render, staticRenderFns } from "./CPrintPage.vue?vue&type=template&id=3065ec19&scoped=true"
import script from "./CPrintPage.vue?vue&type=script&lang=ts"
export * from "./CPrintPage.vue?vue&type=script&lang=ts"
import style0 from "./CPrintPage.vue?vue&type=style&index=0&id=3065ec19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3065ec19",
  null
  
)

export default component.exports